// extracted by mini-css-extract-plugin
export default {"root":"CardHeader-module--root--2c193","center":"CardHeader-module--center--4bd36","addSpacing":"CardHeader-module--add-spacing--92229"};